import axios from "axios";
import { BASE_URL_CONTENT } from "../store";
import modelContentPage from "../models/contentPage";

export const contentPage = (url, locale) => async () => {
  const response = await axios.get(
    `${BASE_URL_CONTENT}/index.php/${locale.substring(0, 2)}/${url}`
  );
  if (response.statusText === "OK") {
    let data = response.data;

    return modelContentPage(data);
  } else {
    throw response.status;
  }
};



// WEBPACK FOOTER //
// ./src/redux/api/contentPage.js